import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { Modal } from "react-bootstrap";
import { StripeProvider, Elements } from "react-stripe-elements";
import {
  COMMON_FAIL_MESSAGE,
  STRIPE_PUBLISHABLE_KEY,
  validateEmail,
} from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  openPaymentGatewayInfoModal,
  createCustomerStripeToken,
  addStripeToken,
  updateCustomerStripeToken,
} from "TicketAction";
import { showError, showSuccess } from "ReduxErrorBar";
import AddPayfastForm from "./add-payfast-form";
import LocaleStrings from "Languages";

class AddPayfastInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isOtherInfoSaved: false,
      tokenNo: "",
      cardNo: "",
      clientemail: "",
      merchantid: "",
      merchantkey: "",
    };
  }

  componentDidMount() {}

  closeModal = () => {
    this.props.reset();
    this.props.openPaymentGatewayInfoModal({ showModal: false });
    this.setState({
      isOtherInfoSaved: false,
      tokenNo: "",
      cardNo: "",
      clientemail: "",
      merchantid: "",
      merchantkey: "",
    });
  };

  tokenReceived = (token, error) => {
    let { clientemail, merchantid, merchantkey } = this.state;
    let { session, SettingData } = this.props;

    if (!error) {
      // this.setState({isOtherInfoSaved: true, tokenNo: token.id, cardNo: token.card.id})
      let values = {
        clientemail: clientemail,
        merchantid: merchantid,
        merchantkey: merchantkey,
        tokenid: token.id,
        cardid: token.card.id,
      };

      this.props.createCustomerStripeToken(session, values, (response) => {
        if (response.success) {
          let custid = response.custid;
          let merchectData = JSON.stringify([
            { merchantid: values.merchantid, merchantkey: values.merchantkey },
          ]);
          let data = {
            id: SettingData.resource[0].id,
            paymentgatewaytype: "payfast",
            paymentgatewaysettingjson: merchectData,
            stripecustomerid: custid,
            stripecustomercardid: values.cardid,
          };

          this.props.addStripeToken(session, data, (res) => {
            // this.setState({loading: false});

            if (res.success == 1) {
              this.props.showSuccess(
                LocaleStrings.tickets_payfast_form_success
              );
              this.closeModal();
            } else {
              this.props.showError(COMMON_FAIL_MESSAGE);
            }
          });
        } else {
          // this.setState({loading: false});
          this.props.showError(LocaleStrings.tickets_payfast_form_error);
        }
      });
    } else {
      this.props.showError(error.message);
      // this.setState({isOtherInfoSaved: false, tokenNo: '', cardNo: ''})
    }
  };

  updateTokenReceived = (token, error) => {
    if (!error) {
      this.setState(
        { isOtherInfoSaved: false, tokenNo: token.id, cardNo: token.card.id },
        () => {
          this.onSubmitForm({});
        }
      );
    } else {
      this.props.showError(error.message);
      this.setState({ isOtherInfoSaved: false, tokenNo: "", cardNo: "" });
    }
  };

  onSubmitForm = (values) => {
    let { session, SettingData, editMode, showModal } = this.props;
    let { tokenNo, cardNo } = this.state;
    // values.tokenid = tokenNo;
    // values.cardid = cardNo;

    // debugger;

    this.setState({ loading: true });
    if (showModal.update && editMode) {
      // Update section
      if (showModal.update === "merchant") {
        let merchectData = JSON.stringify([
          { merchantid: values.merchantid, merchantkey: values.merchantkey },
        ]);
        let data = {
          id: SettingData.resource[0].id,
          paymentgatewaytype: "payfast",
          paymentgatewaysettingjson: merchectData,
        };

        this.props.addStripeToken(session, data, (res) => {
          this.setState({ loading: false });

          if (res.success == 1) {
            this.props.showSuccess(
              LocaleStrings.tickets_payfast_form_merchant_update_success
            );
            this.closeModal();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        });
      } else {
        let updata = {
          stripecustomerid: SettingData.resource[0].stripecustomerid,
          tokenid: tokenNo,
        };
        this.props.updateCustomerStripeToken(session, updata, (response) => {
          if (response.success) {
            let cardid = response.cardid;
            let data = {
              id: SettingData.resource[0].id,
              paymentgatewaytype: "payfast",
              stripecustomercardid: cardid,
            };

            this.props.addStripeToken(session, data, (res) => {
              this.setState({ loading: false });

              if (res.success == 1) {
                this.props.showSuccess(
                  LocaleStrings.tickets_payfast_form_card_update_success
                );
                this.closeModal();
              } else {
                this.props.showError(COMMON_FAIL_MESSAGE);
              }
            });
          } else {
            this.setState({ loading: false });
            this.props.showError(LocaleStrings.tickets_payfast_form_error);
          }
        });
      }
    } else {
      // New create section
      this.setState({
        clientemail: values.clientemail,
        merchantid: values.merchantid,
        merchantkey: values.merchantkey,
      });

      setTimeout(() => {
        this.setState({ isOtherInfoSaved: true });
        this.setState({ loading: false });
      }, 2000);
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      showModal,
      editMode,
    } = this.props;
    let { isOtherInfoSaved } = this.state;

    return (
      <div>
        <Modal
          className="modal-container"
          show={showModal.showModal === true ? true : false}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="cardInfoModal"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {editMode
                ? LocaleStrings.tickets_payfast_modal_update_title
                : `${LocaleStrings.tickets_payfast_modal_add_title} - ${
                    isOtherInfoSaved ? LocaleStrings.step2 : LocaleStrings.step1
                  }`}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>
              {showModal.update && showModal.update != "" ? (
                showModal.update === "card" ? (
                  <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
                    <Elements>
                      <AddPayfastForm
                        {...this.props}
                        onTokenReceived={this.updateTokenReceived}
                        onCloseModal={this.closeModal}
                      />
                    </Elements>
                  </StripeProvider>
                ) : (
                  <form onSubmit={handleSubmit(this.onSubmitForm)}>
                    <OtherInfoForm {...this.props} />

                    <div className="text-right">
                      <Button
                        className="btn btn-custom-white"
                        onClick={this.closeModal}
                      >
                        {LocaleStrings.button_close}
                      </Button>
                      <Button
                        className="btn btn-custom-blue ml-10"
                        loading={this.state.loading}
                        disabled={pristine || invalid || submitting}
                        type="submit"
                      >
                        {LocaleStrings.button_save}
                      </Button>
                    </div>
                  </form>
                )
              ) : isOtherInfoSaved === true ? (
                <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
                  <Elements>
                    <AddPayfastForm
                      {...this.props}
                      onTokenReceived={this.tokenReceived}
                      onCloseModal={this.closeModal}
                    />
                  </Elements>
                </StripeProvider>
              ) : (
                <form onSubmit={handleSubmit(this.onSubmitForm)}>
                  <OtherInfoForm {...this.props} />

                  <div className="text-right">
                    <Button
                      className="btn btn-custom-white"
                      onClick={this.closeModal}
                    >
                      {LocaleStrings.button_close}
                    </Button>
                    <Button
                      className="btn btn-custom-blue ml-10"
                      loading={this.state.loading}
                      disabled={pristine || invalid || submitting}
                      type="submit"
                    >
                      {LocaleStrings.button_save_next}
                    </Button>
                  </div>
                </form>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var toEdit = false;
  var initVals = { clientemail: state.session.emailid };

  if (
    state.paymentGatewayModal &&
    state.paymentGatewayModal.update &&
    state.paymentGatewayModal.update != ""
  ) {
    toEdit = true;

    if (
      state.SettingData &&
      state.SettingData.resource &&
      state.SettingData.resource.length > 0 &&
      state.paymentGatewayModal.update === "merchant"
    ) {
      let merchantInfo = JSON.parse(
        state.SettingData.resource[0].paymentgatewaysettingjson
      );

      initVals = {
        merchantid: merchantInfo[0].merchantid,
        merchantkey: merchantInfo[0].merchantkey,
      };
    }
  }

  return {
    session: state.session,
    showModal: state.paymentGatewayModal,
    editMode: toEdit,
    initialValues: initVals,
    SettingData: state.SettingData,
  };
}

function validate(values, ownProps) {
  var errors = {};
  var clientemail = values["clientemail"];
  var merchantid = values["merchantid"];
  var merchantkey = values["merchantkey"];

  if (!ownProps.editMode) {
    if (!clientemail || clientemail.trim() === "") {
      errors["clientemail"] = LocaleStrings.required;
    }
    if (clientemail && !validateEmail(clientemail)) {
      errors["clientemail"] =
        LocaleStrings.tickets_payfast_form_validaton_invalid_email;
    }
  }

  if (!merchantid || merchantid.trim() === "") {
    errors["merchantid"] = LocaleStrings.required;
  }
  if (!merchantkey || merchantkey.trim() === "") {
    errors["merchantkey"] = LocaleStrings.required;
  }

  return errors;
}

// export default connect(mapStateToProps, {openPaymentGatewayInfoModal,showError,showSuccess})(AddPayfastInfo);
export default connect(mapStateToProps, {
  openPaymentGatewayInfoModal,
  createCustomerStripeToken,
  addStripeToken,
  updateCustomerStripeToken,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "PayfastForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddPayfastInfo)
);

class OtherInfoForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  renderFieldText(field) {
    var labelposition = field.labelposition;

    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <div className="col-sm-11">
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              maxLength={field.maxlength ? field.maxlength : ""}
            />
          </div>
          {field.input.name != "clientemail" ? (
            <div className="col-sm-1">
              <a href="https://www.payfast.co.za/" target="blank">
                <i
                  className="fa fa-info-circle"
                  style={{ color: "#2676ea", fontSize: 20, marginTop: 11 }}
                  aria-hidden="true"
                ></i>
              </a>
            </div>
          ) : (
            ""
          )}
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { showModal } = this.props;

    return (
      <div className="basicform">
        {showModal.update && showModal.update === "merchant" ? (
          ""
        ) : (
          <Field
            name="clientemail"
            label={LocaleStrings.tickets_payfast_form_label_clientemail}
            placeholder={LocaleStrings.tickets_payfast_form_ph_clientemail}
            type="text"
            mandatory="true"
            component={this.renderFieldText}
            labelposition={LABEL_POSITION_TOP}
          />
        )}
        <Field
          name="merchantid"
          label={LocaleStrings.tickets_payfast_form_label_merchant_id}
          placeholder={LocaleStrings.tickets_payfast_form_ph_merchant_id}
          type="text"
          mandatory="true"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="merchantkey"
          label={LocaleStrings.tickets_payfast_form_label_merchant_key}
          placeholder={LocaleStrings.tickets_payfast_form_ph_merchant_key}
          type="text"
          mandatory="true"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}
